module.exports = __webpack_public_path__ + "static/media/14UNEP5.08347373.jpg";